import { render, staticRenderFns } from "./DeliveryStats.vue?vue&type=template&id=51174306"
import script from "./DeliveryStats.vue?vue&type=script&lang=js"
export * from "./DeliveryStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports